export default __webpack_public_path__ + "static/media/remigoo.9255253e.png";